var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        modalNova: true,
        closeOutside: false,
        titulo: _vm.isEdicao ? _vm.demanda.nome : "Cadastrar demanda",
        width: 800
      },
      on: { closeModal: _vm.closeModal }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "validation-observer",
            { ref: "observer" },
            [
              _c(
                "el-row",
                { staticClass: "container", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: {
                                    label: "Nome da demanda:",
                                    required: true
                                  }
                                }),
                                _c("el-input", {
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: { maxlength: 50, type: "text" },
                                  model: {
                                    value: _vm.demanda.nome,
                                    callback: function($$v) {
                                      _vm.$set(_vm.demanda, "nome", $$v)
                                    },
                                    expression: "demanda.nome"
                                  }
                                }),
                                _c("br"),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-label", {
                        attrs: {
                          label: "Responsável pela demanda:",
                          required: false
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "input select",
                          attrs: {
                            filterable: "filterable",
                            multiple: "multiple",
                            "collapse-tags": "collapse-tags",
                            "filter-method": _vm.filtrarResponsaveis,
                            placeholder: "Selecione",
                            "value-key": "id"
                          },
                          model: {
                            value: _vm.demanda.responsaveis,
                            callback: function($$v) {
                              _vm.$set(_vm.demanda, "responsaveis", $$v)
                            },
                            expression: "demanda.responsaveis"
                          }
                        },
                        _vm._l(_vm.responsaveisFiltrados, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.pessoa.nomeRazaoSocial,
                              value: item
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "container", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: {
                                    label: "Data de início:",
                                    required: true
                                  }
                                }),
                                _c("el-date-picker", {
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: {
                                    type: "date",
                                    placeholder: "Selecione",
                                    format: "dd/MM/yyyy"
                                  },
                                  model: {
                                    value: _vm.demanda.dataInicio,
                                    callback: function($$v) {
                                      _vm.$set(_vm.demanda, "dataInicio", $$v)
                                    },
                                    expression: "demanda.dataInicio"
                                  }
                                }),
                                _c("br"),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: {
                                    label: "Data de entrega:",
                                    required: true
                                  }
                                }),
                                _c("el-date-picker", {
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: {
                                    type: "date",
                                    placeholder: "Selecione",
                                    format: "dd/MM/yyyy"
                                  },
                                  model: {
                                    value: _vm.demanda.dataEntrega,
                                    callback: function($$v) {
                                      _vm.$set(_vm.demanda, "dataEntrega", $$v)
                                    },
                                    expression: "demanda.dataEntrega"
                                  }
                                }),
                                _c("br"),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "container", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-label", {
                        attrs: { label: "Estado da demanda:", required: false }
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "input select",
                          attrs: {
                            placeholder: "Selecione",
                            "value-key": "id"
                          },
                          model: {
                            value: _vm.demanda.estadoDemanda,
                            callback: function($$v) {
                              _vm.$set(_vm.demanda, "estadoDemanda", $$v)
                            },
                            expression: "demanda.estadoDemanda"
                          }
                        },
                        _vm._l(_vm.estados, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.nome, value: item }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-label", {
                        attrs: {
                          label: "Prioridade da demanda:",
                          required: false
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "color-group" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input select",
                              attrs: {
                                placeholder: "Selecione",
                                "value-key": "id"
                              },
                              model: {
                                value: _vm.demanda.prioridade,
                                callback: function($$v) {
                                  _vm.$set(_vm.demanda, "prioridade", $$v)
                                },
                                expression: "demanda.prioridade"
                              }
                            },
                            _vm._l(_vm.prioridades, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.nome, value: item }
                              })
                            }),
                            1
                          ),
                          _c("div", {
                            staticClass: "color",
                            style: _vm.corSelecionada
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "container", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-label", {
                        attrs: { label: "Descrição:", required: false }
                      }),
                      _c("el-input", {
                        staticClass: "input",
                        attrs: { resize: "none", type: "textarea", rows: "4" },
                        model: {
                          value: _vm.demanda.descricao,
                          callback: function($$v) {
                            _vm.$set(_vm.demanda, "descricao", $$v)
                          },
                          expression: "demanda.descricao"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "container last", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-label", {
                        staticClass: "labelUpload",
                        attrs: { label: "Upload de Arquivos:", required: false }
                      }),
                      _c("validation-provider", {
                        attrs: { rules: _vm.isValidate },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-anexo", {
                                  staticClass: "upload",
                                  attrs: {
                                    id: "upload-arquivo",
                                    showAnexar: true,
                                    files: _vm.demanda.arquivos,
                                    errors: errors
                                  },
                                  on: {
                                    removeFile: _vm.removeFile,
                                    uploadFile: _vm.uploadFile,
                                    downloadDocumentoCadastro: _vm.download
                                  },
                                  model: {
                                    value: _vm.demanda.arquivos,
                                    callback: function($$v) {
                                      _vm.$set(_vm.demanda, "arquivos", $$v)
                                    },
                                    expression: "demanda.arquivos"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "container last", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-label", {
                        attrs: { label: "Atividades:", required: false }
                      }),
                      _c(
                        "el-button",
                        { on: { click: _vm.adicionarAtividade } },
                        [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _c("span", [_vm._v("  Cadastrar atividades")])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.demanda.atividades, function(atividade) {
                return _c(
                  "div",
                  { staticClass: "atividade" },
                  [
                    _c(
                      "div",
                      { staticClass: "atividade-square" },
                      [
                        _c("el-checkbox", {
                          staticClass: "atividades-square",
                          model: {
                            value: atividade.concluido,
                            callback: function($$v) {
                              _vm.$set(atividade, "concluido", $$v)
                            },
                            expression: "atividade.concluido"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "atividade-content" },
                      [
                        _c("el-input", {
                          ref: "inputAtividade",
                          refInFor: true,
                          staticClass: "input",
                          attrs: { placeholder: "Nome da atividade" },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.adicionarAtividade($event)
                            }
                          },
                          model: {
                            value: atividade.nome,
                            callback: function($$v) {
                              _vm.$set(atividade, "nome", $$v)
                            },
                            expression: "atividade.nome"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "excluir atividade-square",
                        on: {
                          click: function($event) {
                            return _vm.excluirAtividade(atividade)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-trash" })]
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "container-footer" },
          [
            _c("app-buttons-cadastro", {
              attrs: {
                isPrimeiroPasso: true,
                isUltimoPasso: true,
                showButtonCancelar: _vm.isEdicao,
                showButtonSalvar: false,
                showButtonDownload: false,
                finalizarLabel: _vm.isEdicao ? "Salvar" : "Cadastrar",
                cancelarLabel: "Excluir"
              },
              on: { finalizar: _vm.confirmar, cancelar: _vm.excluir }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11914ac4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11914ac4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/ModalCadastrarDemanda.vue
// module id = null
// module chunks = 